module.exports = __webpack_public_path__ + "static/media/rotate_icon.38f4dd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/rotate_icon.png
// module id = 2253
// module chunks = 0